<template>
    <div class="notification-settings">
        <!-- Alertes ponctuelles par email -->
        <div class="card card-alerts">
            <header>
                <i class="fa-solid fa-bell"></i>
                {{ $t("dash.settings.notifications.alerts.title") }}
            </header>
            <div class="content">
                <p class="section-intro">{{ $t("dash.settings.notifications.alerts.subtitle") }}</p>

                <div class="alerts-grid">
                    <div class="alert-tile" v-for="alert in alerts" :key="alert.key" :class="{ active: isEnabled(alert.key) }">
                        <div class="alert-icon"><i :class="alert.icon"></i></div>
                        <div class="alert-text">
                            <h4>{{ $t(`dash.settings.notifications.${alert.i18n}.content.title`) }}</h4>
                            <p>{{ $t(`dash.settings.notifications.${alert.i18n}.content.subtitle`) }}</p>
                        </div>
                        <ComponentSwitch :value="isEnabled(alert.key)" :onChange="handleChangeStateNotification" :id="alert.key"></ComponentSwitch>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bilans automatiques par email (masqués en prod, uniquement sur les envs V2) -->
        <ReportSchedules v-if="isReportingV2Env" :infoUser="infoUser" :pages="accessiblePages" :groups="groups"></ReportSchedules>
    </div>
</template>

<script>

import ComponentSwitch from './../utils/switch.vue'
import ReportSchedules from './report-schedules.vue'
import User from '../../mixins/User'

export default {
    name: 'notification-settings',

    components :{
        ComponentSwitch,
        ReportSchedules
    },

    props : {
      infoUser : Object,
      updateInfoUser : Function,
      allPages : {
        type : Array,
        default : () => []
      },
      groups : {
        type : Array,
        default : () => []
      },
    },

    mixins: [User],

    data() {
        return {
            notifications : {
                info : null,
                error : null,
                inbox : null,
                page: null,
                source: null,
            },
            timeoutInitSaveInfo : null,
        };
    },

    mounted() {
        if(this.infoUser.notifications)
            this.notifications = {...this.infoUser.notifications};
    },


    methods: {
        activeInbox() {
            const accounts = [
                'd12717da-7255-4d0d-a77c-417578e016a8', //sandbox test
                '8478452f-909b-4775-a2b4-329fbd0a90ec', //cyber-id
                '9e046e84-5b26-4c94-8379-9a88ea278490', //ledivan
                '57524522-10fc-414d-9d5b-852a57d67780', //fb permission
            ]

            const force = localStorage.forceInbox ? JSON.parse(localStorage.forceInbox) : false
            return this.infoUser && (accounts.includes(this.infoUser.account) || (this.infoUser.email || "").includes("@mashup-web.com") || this.activeInstagramStories() || force == true)
        },

        activeInstagramStories() {
            const accounts = [
                '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
                'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
                'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
                '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
                '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
                '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
                '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
                '90e789fa-7377-434c-b719-132aa8bcd1d2',  //keepeo.fr
                'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
                '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
                '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
                '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
            ]

            const user = JSON.parse(localStorage.user)
            return accounts.includes(user.account) || this.checkLock('instagram_credentials') || user.email.includes("@mashup-web.com")
        },

        buildSaveData() {
            return {
                id: this.infoUser.id,
                ['notifications[info]'] : this.notifications.info,
                ['notifications[error]'] : this.notifications.error,
                ['notifications[inbox]'] : this.notifications.inbox,
                ['notifications[page]'] : this.notifications.page,
                ['notifications[source]'] : this.notifications.source,
            }
        },

        isEnabled(key) {
            return this.notifications[key] == true || this.notifications[key] == 'true'
        },

        handleChangeStateNotification(value, key) {
            this.notifications[key] = value.toString();
            this.scheduleSave()
        },

        scheduleSave() {
            if (this.timeoutInitSaveInfo) clearTimeout(this.timeoutInitSaveInfo)
            this.timeoutInitSaveInfo = setTimeout(() => {
                this.updateInfoUser(this.buildSaveData())
            }, 1000);
        },
    },

    computed: {
        isReportingV2Env() {
            return (process.env.VUE_APP_REPORTING_VERSION || '1') !== '1'
        },

        alerts() {
            return [
                { key: 'error', i18n: 'echec', icon: 'fa-solid fa-triangle-exclamation' },
                { key: 'info', i18n: 'validation', icon: 'fa-solid fa-comment-dots' },
                ...(this.activeInbox() ? [{ key: 'inbox', i18n: 'inbox', icon: 'fa-solid fa-inbox' }] : []),
                { key: 'page', i18n: 'page', icon: 'fa-solid fa-plug' },
                { key: 'source', i18n: 'source', icon: 'fa-solid fa-rss' },
            ]
        },

        accessiblePages() {
            if (!this.infoUser) return []
            if (this.infoUser.admin) return this.allPages
            const access = this.infoUser.pages_access || []
            return this.allPages.filter(page => access.includes(page.id))
        },
    },

    watch : {
      infoUser() {
        this.notifications = {...this.infoUser.notifications};
      }
    },

    beforeDestroy() {
        if (this.timeoutInitSaveInfo) {
            clearTimeout(this.timeoutInitSaveInfo)
            this.updateInfoUser(this.buildSaveData())
        }
    },
};
</script>